import { SvgIcon, SvgIconProps } from "@mui/material";
import { memo } from "react";
const SvgArrowMiniRight32 = (props: SvgIconProps) => {
  const {
    sx,
    ...other
  } = props;
  return <SvgIcon xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" sx={{
    ...sx
  }} {...other}><path fill="currentColor" d="M13.043 21.354a.5.5 0 0 0 .707 0L19.104 16l-5.354-5.354a.5.5 0 0 0-.707.708L17.689 16l-4.646 4.646a.5.5 0 0 0 0 .708" /></SvgIcon>;
};
const Memo = memo(SvgArrowMiniRight32);
export default Memo;